/**
 * Google Tag Manager
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */

import ServerView from '../../framework/server-side-view';

const View = ServerView.extend({
	el: 'body .js-gtm-data',

	events: {
		'click': 'onClick',
	},


	onClick(e) {
		this.addToDataLayer(e);
	},

	addToDataLayer(e) {
		if (e.currentTarget.dataset.jsGtmData) {
			const { event, eventaction, eventcategory, eventlabel } = JSON.parse(e.currentTarget.dataset.jsGtmData);
			dataLayer.push({
				event,
				eventaction,
				eventcategory,
				eventlabel,
			});
		}

		if (e.currentTarget.dataset.jsGtmDataSubmit) {
			const { event, eventaction, eventcategory, eventlabel } = JSON.parse(e.currentTarget.dataset.jsGtmDataSubmit);
			window.gtmDataSubmit = { event, eventaction, eventcategory, eventlabel };
		}

		if (e.currentTarget.dataset.jsGtmDataSubmitMarketing) {
			const { event, eventaction, eventcategory, eventlabel } = JSON.parse(e.currentTarget.dataset.jsGtmDataSubmitMarketing);
			window.gtmDataSubmitMarketing = { event, eventaction, eventcategory, eventlabel };
		}
	},
});

export default View;
